export const state = () => ({
  info: null,
  STATUS_CALL: {
    ACCEPTING: 'ACCEPTING',
    CALLING: 'CALLING',
    RINGING: 'RINGING',
    CONNECTED: 'CONNECTED'
  },
  STATUS_CONSULTATION: {
    CALLED: 'CALLED',
    COMPLETED: 'COMPLETED'
  },
  drawer: false,
  drawerTab: -1,
  messages: []
})